<div class="greco-timezone-select-container">
  <mat-select [formControl]="_formControl" [required]="required">
    <mat-option *ngFor="let timezone of timezones$ | async" [value]="timezone">
      {{ timezone }}
    </mat-option>
  </mat-select>
</div>
